import React, { Component } from "react";

class Footer extends Component {
  render() {
    return (
      <footer>
        <div id="footerDiv">
          <p>
            -- PHARMACY MANAGEMENT SYSTEM PROJECT "EDYODA DIGITAL UNIVERSITY" --
          </p>
        </div>
      </footer>
    );
  }
}

export default Footer;
